// Good moments (badge earned, day completed) where asking for a review is welcome.
const EVENT = 'goaltree:positive-moment'

export function emitPositiveMoment() {
  window.dispatchEvent(new Event(EVENT))
}

export function onPositiveMoment(cb: () => void) {
  window.addEventListener(EVENT, cb)
  return () => window.removeEventListener(EVENT, cb)
}
